import React from 'react';
import Container from "./Components/TabContainer";
import JobOpportunity from "./Components/Forms/JobOpportunity";
import {createRoot} from "react-dom/client";

const tabs = document.getElementById('job-opportunity-tabs');
const form = document.getElementById('job-opportunity-form-container');

if (tabs) {
    createRoot(tabs).render(<Container {...(tabs.dataset)} />);
}

if (form) {
    createRoot(form).render(<JobOpportunity {...(form.dataset)} />);
}